const module = {
  getters: {
    links: (state, getters, rootState) => rootState.eventTypes.eventTypes
      .filter((x) => x.name !== 'IN-PERSON/VIRTUAL')
      .filter((type) => rootState.events.events
        .some((event) => event.typeEvent.name === type.name)),
  },
};

export default module;
